var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"activity-container"},[_c('Content',{attrs:{"item":_vm.item}}),_c('section',{staticClass:"activity-content"},[_c('ul',{staticClass:"activity-list"},_vm._l((_vm.activities),function(activity,index){return _c('li',{key:index},[_c('div',{staticClass:"content"},[_c('h3',[_c('router-link',{attrs:{"to":{
              name: 'activityDetail',
              params: {
                id: activity.id
              }
            }}},[_vm._v(_vm._s(activity.title))])],1),_c('p',{staticClass:"date"},[_vm._v("时间："+_vm._s(activity.time))]),_c('p',[_c('router-link',{style:({
              'font-weight': 'bold',
            }),attrs:{"to":{
            name: 'activityDetail',
            params: {
              id: activity.id
            }
          }}},[_vm._v("查看更多")])],1)]),_c('div',{staticClass:"outpage"},[_c('router-link',{attrs:{"to":{
            name: 'activityDetail',
            params: {
              id: activity.id
            }
          }}},[_c('img',{attrs:{"src":activity.img,"alt":""}})])],1)])}),0)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }